// Order Status Groups
export const STATUS_GROUPS = {
  pending: [0, 13], // PENDING, PREORDER
  inProgress: [7, 4, 8, 3, 9, 14, 18, 19, 20, 21, 22, 23, 24, 25, 26], // All in-progress statuses
  completed: [1, 11, 15], // COMPLETED_BY_ADMIN, DELIVERY_COMPLETED_BY_DRIVER, ORDER_PICKEDUP_COMPLETED_BY_CUSTOMER
  cancelled: [2, 5, 6, 10, 12, 16, 17], // All cancelled statuses
};

// Status Labels for Display - Centralized and consistent labels
export const STATUS_LABELS = {
  0: "Pending",
  13: "Preorder",
  7: "Accepted by business",
  4: "Preparation Completed",
  8: "Accepted by driver",
  3: "Driver arrived to business",
  9: "Pick up completed by driver",
  14: "Order not ready",
  18: "Driver almost arrived to business",
  19: "Driver almost arrived to customer",
  20: "Customer almost arrived to business",
  21: "Customer arrived to business",
  22: "Looking for driver",
  23: "Driver on way",
  24: "Driver waiting for order",
  25: "Accepted by driver company",
  26: "Driver arrived to customer",
  1: "Completed by admin",
  11: "Delivery completed by driver",
  15: "Pickup completed by customer",
  2: "Rejected by admin",
  5: "Rejected by business",
  6: "Rejected by driver",
  10: "Pick up Failed by driver",
  12: "Delivery Failed by driver",
  16: "Cancelled by customer",
  17: "Not picked by customer",
};

export const STATUS_LABEL_KEYS = {
  0: "orders.statusLabels.0",
  1: "orders.statusLabels.1",
  2: "orders.statusLabels.2",
  3: "orders.statusLabels.3",
  4: "orders.statusLabels.4",
  5: "orders.statusLabels.5",
  6: "orders.statusLabels.6",
  7: "orders.statusLabels.7",
  8: "orders.statusLabels.8",
  9: "orders.statusLabels.9",
  10: "orders.statusLabels.10",
  11: "orders.statusLabels.11",
  12: "orders.statusLabels.12",
  13: "orders.statusLabels.13",
  14: "orders.statusLabels.14",
  15: "orders.statusLabels.15",
  16: "orders.statusLabels.16",
  17: "orders.statusLabels.17",
  18: "orders.statusLabels.18",
  19: "orders.statusLabels.19",
  20: "orders.statusLabels.20",
  21: "orders.statusLabels.21",
  22: "orders.statusLabels.22",
  23: "orders.statusLabels.23",
  24: "orders.statusLabels.24",
  25: "orders.statusLabels.25",
  26: "orders.statusLabels.26",
};

// Status Badge Colors - Centralized color system for all order statuses
export const STATUS_BADGE_COLORS = {
  pending: "bg-yellow-500/10 text-yellow-400 border border-yellow-500/20",
  inProgress: "bg-blue-500/10 text-blue-400 border border-blue-500/20",
  completed: "bg-green-500/10 text-green-400 border border-green-500/20",
  cancelled: "bg-red-500/10 text-red-400 border border-red-500/20",
  unknown: "bg-gray-500/10 text-gray-400 border border-gray-500/20",
};

// Status Icon Colors - For icons and text colors based on status
export const STATUS_ICON_COLORS = {
  pending: "text-yellow-400",
  inProgress: "text-blue-400",
  completed: "text-green-400",
  cancelled: "text-red-400",
  unknown: "text-gray-400",
};

// Status Background Colors - For background elements
export const STATUS_BACKGROUND_COLORS = {
  pending: "bg-yellow-500/10",
  inProgress: "bg-blue-500/10",
  completed: "bg-green-500/10",
  cancelled: "bg-red-500/10",
  unknown: "bg-gray-500/10",
};

// Status Border Colors - For border elements
export const STATUS_BORDER_COLORS = {
  pending: "border-yellow-500/20",
  inProgress: "border-blue-500/20",
  completed: "border-green-500/20",
  cancelled: "border-red-500/20",
  unknown: "border-gray-500/20",
};

// Individual Status Colors - For specific status codes
export const INDIVIDUAL_STATUS_COLORS = {
  // Pending statuses
  0: "text-yellow-400", // Pending
  13: "text-yellow-400", // Preorder

  // In Progress statuses
  7: "text-blue-400", // Accepted by business
  4: "text-blue-400", // Preparation Completed
  8: "text-blue-400", // Accepted by driver
  3: "text-blue-400", // Driver arrived to business
  9: "text-blue-400", // Pick up completed by driver
  14: "text-orange-400", // Order not ready
  18: "text-blue-400", // Driver almost arrived to business
  19: "text-blue-400", // Driver almost arrived to customer
  20: "text-blue-400", // Customer almost arrived to business
  21: "text-blue-400", // Customer arrived to business
  22: "text-blue-400", // Looking for driver
  23: "text-blue-400", // Driver on way
  24: "text-blue-400", // Driver waiting for order
  25: "text-blue-400", // Accepted by driver company
  26: "text-blue-400", // Driver arrived to customer

  // Completed statuses
  1: "text-green-400", // Completed by admin
  11: "text-green-400", // Delivery completed by driver
  15: "text-green-400", // Pickup completed by customer

  // Cancelled statuses
  2: "text-red-400", // Rejected by admin
  5: "text-red-400", // Rejected by business
  6: "text-red-400", // Rejected by driver
  10: "text-red-400", // Pick up Failed by driver
  12: "text-red-400", // Delivery Failed by driver
  16: "text-red-400", // Cancelled by customer
  17: "text-red-400", // Not picked by customer
};

// Channel Configuration
export const CHANNEL_ICONS = {
  WhatsApp: "MessageCircle",
  "Web Chat": "MessageSquare",
  "Phone AI": "Phone",
};

export const CHANNEL_COLORS = {
  WhatsApp: "text-green-400",
  "Web Chat": "text-blue-400",
  "Phone AI": "text-purple-400",
};

export const CHANNELS = ["WhatsApp", "Web Chat", "Phone AI"];
export const CHANNEL_LABEL_KEYS = {
  WhatsApp: "orders.channels.whatsapp",
  "Web Chat": "orders.channels.webChat",
  "Phone AI": "orders.channels.phoneAi",
};

// Filter Tabs Configuration
export const FILTER_TABS = [
  {
    key: "preparing",
    label: "Active",
    labelKey: "orders.tabs.active",
    color: "text-yellow-400",
  },
  {
    key: "completed",
    label: "Completed",
    labelKey: "orders.tabs.completed",
    color: "text-green-400",
  },
  {
    key: "cancelled",
    label: "Cancelled",
    labelKey: "orders.tabs.cancelled",
    color: "text-red-400",
  },
  {
    key: "all",
    label: "All Orders",
    labelKey: "orders.tabs.allOrders",
    color: "text-white",
  },
];

export const ORDER_SEARCH_FIELDS = {
  ORDER_ID: "orderId",
  CUSTOMER_FIRST_NAME: "customerFirstName",
  CUSTOMER_LAST_NAME: "customerLastName",
  CUSTOMER_PHONE: "customerPhone",
  CUSTOMER_CELLPHONE: "customerCellphone",
  BUSINESS_NAME: "businessName",
};

export const ORDER_SEARCH_OPTIONS = [
  {
    value: ORDER_SEARCH_FIELDS.ORDER_ID,
    labelKey: "search.fields.orderId",
  },
  {
    value: ORDER_SEARCH_FIELDS.CUSTOMER_FIRST_NAME,
    labelKey: "search.fields.customerFirstName",
  },
  {
    value: ORDER_SEARCH_FIELDS.CUSTOMER_LAST_NAME,
    labelKey: "search.fields.customerLastName",
  },
  {
    value: ORDER_SEARCH_FIELDS.CUSTOMER_CELLPHONE,
    labelKey: "search.fields.customerCellphone",
  },
  {
    value: ORDER_SEARCH_FIELDS.BUSINESS_NAME,
    labelKey: "search.fields.businessName",
  },
];

// Date Filter Options
export const DATE_FILTER_OPTIONS = [
  { value: "today", label: "Today", labelKey: "common.date.today" },
  { value: "yesterday", label: "Yesterday", labelKey: "common.date.yesterday" },
  { value: "week", label: "This Week", labelKey: "common.date.thisWeek" },
  { value: "month", label: "This Month", labelKey: "common.date.thisMonth" },
  { value: "all", label: "All Time", labelKey: "common.date.allTime" },
];

// Utility Functions
export const getStatusGroup = (status) => {
  if (STATUS_GROUPS.pending.includes(status)) return "pending";
  if (STATUS_GROUPS.inProgress.includes(status)) return "inProgress";
  if (STATUS_GROUPS.completed.includes(status)) return "completed";
  if (STATUS_GROUPS.cancelled.includes(status)) return "cancelled";
  return "unknown";
};

// Color utility functions
export const getStatusIconColor = (status) => {
  const statusGroup = getStatusGroup(status);
  return STATUS_ICON_COLORS[statusGroup] || STATUS_ICON_COLORS.unknown;
};

export const getStatusBackgroundColor = (status) => {
  const statusGroup = getStatusGroup(status);
  return (
    STATUS_BACKGROUND_COLORS[statusGroup] || STATUS_BACKGROUND_COLORS.unknown
  );
};

export const getStatusBorderColor = (status) => {
  const statusGroup = getStatusGroup(status);
  return STATUS_BORDER_COLORS[statusGroup] || STATUS_BORDER_COLORS.unknown;
};

export const getStatusBadgeColor = (status) => {
  const statusGroup = getStatusGroup(status);
  return STATUS_BADGE_COLORS[statusGroup] || STATUS_BADGE_COLORS.unknown;
};

export const getIndividualStatusColor = (status) => {
  return INDIVIDUAL_STATUS_COLORS[status] || STATUS_ICON_COLORS.unknown;
};

export const getCustomerName = (order) => {
  return (
    [order?.customer?.name, order?.customer?.lastname]
      .filter(Boolean)
      .join(" ")
      .trim() || "Customer"
  );
};

export const getCustomerPhone = (order, returnValue) => {
  const countryPhoneCode = order?.customer?.country_phone_code
    ? `+${order?.customer?.country_phone_code}`
    : "";

  return (
    [countryPhoneCode, order?.customer?.cellphone]
      .filter(Boolean)
      .join(" ")
      .trim() ||
    (returnValue ?? "No data")
  );
};

export const ITEMS_PER_PAGE = 15;
export const MAX_VISIBLE_PAGES = 5;

export const paramsToSend = {
  params:
    "id,external_id,conversation_id,status,products,summary,customer,delivery_datetime_utc,created_at,taxes,business",
  mode: "dashboard",
  orderBy: "-id",
  page: 1,
  page_size: ITEMS_PER_PAGE,
};

const buildSearchFilterCondition = (searchBy, searchValue) => {
  switch (searchBy) {
    case ORDER_SEARCH_FIELDS.CUSTOMER_FIRST_NAME:
      return {
        attribute: "customer",
        conditions: [
          {
            attribute: "name",
            value: {
              condition: "ilike",
              value: searchValue,
            },
          },
        ],
      };
    case ORDER_SEARCH_FIELDS.CUSTOMER_LAST_NAME:
      return {
        attribute: "customer",
        conditions: [
          {
            attribute: "lastname",
            value: {
              condition: "ilike",
              value: searchValue,
            },
          },
        ],
      };
    case ORDER_SEARCH_FIELDS.CUSTOMER_PHONE:
      return {
        attribute: "customer",
        conditions: [
          {
            attribute: "phone",
            value: {
              condition: "ilike",
              value: searchValue,
            },
          },
        ],
      };
    case ORDER_SEARCH_FIELDS.CUSTOMER_CELLPHONE:
      return {
        attribute: "customer",
        conditions: [
          {
            attribute: "cellphone",
            value: {
              condition: "ilike",
              value: searchValue,
            },
          },
        ],
      };
    case ORDER_SEARCH_FIELDS.BUSINESS_NAME:
      return {
        attribute: "business",
        conditions: [
          {
            attribute: "name",
            value: {
              condition: "ilike",
              value: searchValue,
            },
          },
        ],
      };
    case ORDER_SEARCH_FIELDS.ORDER_ID:
    default:
      return {
        attribute: "id",
        value: {
          condition: "ilike",
          value: searchValue,
        },
      };
  }
};

const padDateTimePart = (n) => String(n).padStart(2, "0");

/**
 * Formats a Date in local time as `YYYY-MM-DD HH:mm:ss` for orders API filters.
 * @param {Date} date
 * @returns {string}
 */
export const formatOrdersDeliveryDatetimeLocal = (date) => {
  return `${date.getFullYear()}-${padDateTimePart(date.getMonth() + 1)}-${padDateTimePart(date.getDate())} ${padDateTimePart(date.getHours())}:${padDateTimePart(date.getMinutes())}:${padDateTimePart(date.getSeconds())}`;
};

/**
 * Parses `YYYY-MM-DD HH:mm:ss` (local calendar) to epoch ms.
 * @param {string} str
 * @returns {number}
 */
export const parseOrdersFilterLocalDateTime = (str) => {
  const [datePart, timePart] = str.split(" ");
  const [y, m, d] = datePart.split("-").map(Number);
  const [hh, mm, ss] = timePart.split(":").map(Number);
  return new Date(y, m - 1, d, hh, mm, ss).getTime();
};

/**
 * Delivery window for the Orders page time filter (Today vs a calendar month).
 * @param {Date | null} selectedDate - `null` = today; otherwise any date in the target month (UI uses month start).
 * @returns {{ start: string, end: string }}
 */
export const getOrdersDeliveryDatetimeRange = (selectedDate) => {
  const now = new Date();
  if (selectedDate == null) {
    const start = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0,
    );
    const end = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59,
    );
    return {
      start: formatOrdersDeliveryDatetimeLocal(start),
      end: formatOrdersDeliveryDatetimeLocal(end),
    };
  }
  const year = selectedDate.getFullYear();
  const monthIndex = selectedDate.getMonth();
  const start = new Date(year, monthIndex, 1, 0, 0, 0);
  const end = new Date(year, monthIndex + 1, 0, 23, 59, 59);
  return {
    start: formatOrdersDeliveryDatetimeLocal(start),
    end: formatOrdersDeliveryDatetimeLocal(end),
  };
};

/**
 * Local time window for `created_at` filters (e.g. analyze/conversations). Same rules as {@link getOrdersDeliveryDatetimeRange}.
 */
export const getCreatedAtRangeForFilter = getOrdersDeliveryDatetimeRange;

/**
 * Reads >= / <= delivery_datetime bounds from a where clause (if present).
 * @param {object} whereClause
 * @returns {{ startMs: number, endMs: number } | null}
 */
export const getDeliveryDatetimeRangeBoundsFromWhere = (whereClause) => {
  const conditions = whereClause?.conditions;
  if (!Array.isArray(conditions)) {
    return null;
  }
  let startStr;
  let endStr;
  for (const c of conditions) {
    if (
      c.attribute !== "delivery_datetime" ||
      !c.value ||
      typeof c.value !== "object"
    ) {
      continue;
    }
    if (c.value.condition === ">=") {
      startStr = c.value.value;
    }
    if (c.value.condition === "<=") {
      endStr = c.value.value;
    }
  }
  if (!startStr || !endStr) {
    return null;
  }
  return {
    startMs: parseOrdersFilterLocalDateTime(startStr),
    endMs: parseOrdersFilterLocalDateTime(endStr),
  };
};

/**
 * Comparable instant for an order's scheduled delivery (for client-side cache checks).
 * @param {object} order
 * @returns {number | null}
 */
export const getOrderDeliveryTimeMs = (order) => {
  const rawUtc = order?.delivery_datetime_utc;
  const rawLocal = order?.delivery_datetime;
  if (rawUtc != null && rawUtc !== "") {
    const s = String(rawUtc);
    if (s.endsWith("Z") || /[+-]\d{2}:?\d{2}$/.test(s)) {
      return Date.parse(s);
    }
    return Date.parse(`${s}Z`);
  }
  if (rawLocal != null && rawLocal !== "") {
    const s = String(rawLocal).trim();
    const isoTry = s.includes("T") ? s : s.replace(" ", "T");
    const parsed = Date.parse(isoTry);
    if (!Number.isNaN(parsed)) {
      return parsed;
    }
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(s)) {
      return parseOrdersFilterLocalDateTime(s);
    }
  }
  return null;
};

export const buildWhereClause = (
  statusFilter,
  searchTerm = "",
  selectedBrand,
  searchBy = ORDER_SEARCH_FIELDS.ORDER_ID,
  deliveryDatetimeRange,
) => {
  const baseWhere = {
    conditions: [],
    conector: "AND",
  };

  baseWhere.conditions.push({
    attribute: "conversation_id",
    value: {
      condition: "!=",
      value: null,
    },
  });

  if (statusFilter !== "all") {
    let statusValues = [];

    switch (statusFilter) {
      case "preparing":
        statusValues = [...STATUS_GROUPS.pending, ...STATUS_GROUPS.inProgress];
        break;
      case "completed":
        statusValues = STATUS_GROUPS.completed;
        break;
      case "cancelled":
        statusValues = STATUS_GROUPS.cancelled;
        break;
      default:
        statusValues = [];
    }

    if (statusValues.length > 0) {
      baseWhere.conditions.push({
        attribute: "status",
        value: statusValues,
      });
    }
  }

  if (searchTerm && searchTerm.trim()) {
    const searchValue = `%${searchTerm.trim()}%`;
    const searchCondition = buildSearchFilterCondition(searchBy, searchValue);

    baseWhere.conditions.push({
      conector: "AND",
      conditions: [searchCondition],
    });
  }

  if (selectedBrand?.id) {
    baseWhere.conditions.push({
      attribute: "business_id",
      value: selectedBrand.id,
    });
  }

  if (deliveryDatetimeRange?.start && deliveryDatetimeRange?.end) {
    baseWhere.conditions.push({
      attribute: "delivery_datetime",
      value: {
        condition: ">=",
        value: deliveryDatetimeRange.start,
      },
    });
    baseWhere.conditions.push({
      attribute: "delivery_datetime",
      value: {
        condition: "<=",
        value: deliveryDatetimeRange.end,
      },
    });
  }

  return baseWhere;
};
